// extracted by mini-css-extract-plugin
export default {"wrapper":"root_wrapper__asjZG","content":"root_content__z9wTq","msg":"root_msg__FMjZV"};